export default [
    { name: "current_password", label: "Obecne hasło" },
    { name: "password", label: "Nowe hasło" },
    { name: "password_confirmation", label: "Powtórz nowe hasło" }
]